import { Text } from "@volca/ui/components/ui/text";
import type { ApInvoice } from "@/accounts-payable/types";
import { useQuickbooksBillPush } from "./use-quickbooks-bill-push";

/**
 * The line that goes with `QuickbooksBillPushButton`: why the invoice can't be
 * pushed now (the disabled button points here, so it is read on touch and by
 * screen readers, not only on hover), or why the agent didn't push it on its
 * own. Nothing when there is nothing to explain.
 */
export const QuickbooksBillPushNote = ({
  invoice,
  businessId,
}: {
  invoice: Pick<ApInvoice, "id" | "quickbooks_bill">;
  businessId: string | null;
}) => {
  const { isError, note, noteId } = useQuickbooksBillPush(invoice, businessId);

  if (isError)
    return (
      <Text variant="caption" tone="muted">
        Couldn’t check whether this invoice can be pushed to QuickBooks.
      </Text>
    );
  if (!note) return null;

  return (
    <Text id={noteId} variant="caption" tone="muted">
      {note}
    </Text>
  );
};
